import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class AzureCommandNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Azure Command';
        this.id = 'node_azure_command';
        this.linkedFeature = 'azure';

        this.outputs = [
            {
                name: 'Command Triggered',
                portId: 'azure_cmd',
                params: [
                    {
                        name: 'param',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        this.settings = this.settings.concat([
            {
                id: 'CMD',
                name: 'Command',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
                refId: 'azure_command',
                options: [],
            },

        ]);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const links = project.getNodeLinks(this, 'azure_cmd');
        const CMD = this.getSettingValue('CMD');
        const COMMAND_FEATURE = project.getFeature(CMD);
        if (!COMMAND_FEATURE) {
            return blocks;
        }
        const COMMAND_ID = COMMAND_FEATURE?.getSettingValue('COMMAND_ID');

        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: `callback_azure_command_triggered_${COMMAND_ID}`,
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `'****${link.getSourceId()}****'`,
            });
        }
        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev_demo_03';
    }
}
